'use client'

import Link from 'next/link'
import dynamic from 'next/dynamic'
import { usePathname } from 'next/navigation'
import { MenuList, MenuItem, ListItemText, ListItemIcon } from '@mui/material'

// Types
import type { MenuItemsProps } from '@/types/components/molecules/items/menu'

// Helpers
import { useTranslation } from '@/helpers/i18n/client'

// Components
const IconAtom = dynamic(() => import('@/components/atoms/icons'))

const MenuItemsMolecule = (props: MenuItemsProps) => {
	// Props
	const { lng, items } = props

	// Pathname
	const { t } = useTranslation(lng)
	const pathname = usePathname()

	return (
		<MenuList>
			{items.map((item, index) => {
				const link = item.link_value !== '/home' ? item.link_value : `/${lng}`

				return (
					<MenuItem key={index} className={pathname === link ? 'menu-active' : ''} sx={{ px: { md: 0.5, lg: 2 } }}>
						<Link href={link}>
							{item.icon && (
								<ListItemIcon>
									<IconAtom name={item.icon} />
								</ListItemIcon>
							)}

							<ListItemText>{t(item.title)}</ListItemText>
						</Link>
					</MenuItem>
				)
			})}
		</MenuList>
	)
}

export default MenuItemsMolecule
